"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Calendar, Users, Briefcase } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EventsOverview() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const events = [{
    icon: Users,
    title: "Частни събития",
    description: "Организирайте перфектния празник за Вашите близки в уютна и модерна обстановка с персонализирано меню.",
    link: "/EventsPage"
  }, {
    icon: Briefcase,
    title: "Фирмени събития",
    description: "Заведението ни предлага отлични условия за корпоративни срещи, обучения и тийм билдинг активности.",
    link: "/EventsPage"
  }, {
    icon: Calendar,
    title: "Специални поводи",
    description: "Рождени дни, годишнини или просто приятелски събирания – ние ще се погрижим за всеки детайл.",
    link: "/EventsPage"
  }];
  return <section id="събития-преглед" className="dark bg-dark-background text-dark-foreground py-16 px-6 md:px-12 lg:px-16">
      <div className="container">
        <div ref={headerRef} className={`text-center mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          <h2 className="font-display text-[32px] md:text-[40px] font-bold mb-4">
            Организирайте незабравимо събитие
          </h2>
          <p className="text-[16px] md:text-[18px] text-dark-foreground/80 max-w-2xl mx-auto">
            Миш‑Маш /интерпред/ предлага перфектното място за Вашите частни и фирмени събития
          </p>
          <img src="https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-6ce3c7fc10e2caa4da36f325072c2724-V.webp" alt="Events at Mish-Mash" className="w-full max-w-3xl mx-auto mt-8 rounded-xl shadow-medium object-cover aspect-video md:aspect-[21/9]" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {events.map((event, i) => {
          const cardRef = i === 0 ? card1Ref : i === 1 ? card2Ref : card3Ref;
          const cardVisible = i === 0 ? card1Visible : i === 1 ? card2Visible : card3Visible;
          const Icon = event.icon;
          return <div key={i} data-index={i} ref={cardRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`} style={{
            transitionDelay: `${i * 80}ms`
          }}>
                <Card className="h-full flex flex-col bg-dark-background/40 border border-white/10 shadow-clay hover:shadow-clay-hover hover:-translate-y-1.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                  <CardHeader className="text-center">
                    <div className="mx-auto mb-4 flex items-center justify-center size-16 rounded-lg bg-primary/20 text-primary">
                      <Icon className="size-8" />
                    </div>
                    <CardTitle className="text-[22px] font-display font-bold text-dark-foreground">
                      {event.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-1">
                    <p className="text-[15px] text-dark-foreground/75 text-center leading-relaxed">
                      {event.description}
                    </p>
                  </CardContent>
                  <CardFooter className="justify-center pt-4">
                    <Link to={event.link}>
                      <Button variant="outline" className="border-primary/30 text-primary hover:bg-primary/10 hover:border-primary/50 transition-all duration-[var(--duration-fast)] hover:scale-[1.03] active:scale-[0.98]">
                        Научете повече
                      </Button>
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}